export default __webpack_public_path__ + "static/media/loadingSpinnerLmi.f76e9ab1.gif";